export default {
    init: function (state, payload) {
        state.docid = payload.docid;
        state.doctype = payload.doctype;
        state.doclabel = payload.doclabel;
        state.step = payload.step;
        state.docNumberFormat = payload.docNumberFormat;
        state.unitNumberFormat = payload.unitNumberFormat;
        state.rateCategoryId = payload.rateCategoryId;
        state.thirdId = payload.thirdId;
        state.layoutId = payload.layoutId;
        state.langId = payload.langId;
        state.dunningState = payload.dunningState;
        state.deadlines = payload.deadlines;
        state.canEditDocument = payload.canEditDocument;
        state.canBaseEditDocument = payload.canBaseEditDocument;
        state.hasExpensePlugin = payload.hasExpensePlugin;
        state.hasTimeTrackingPlugin = payload.hasTimeTrackingPlugin;
        state.docnumber = payload.docnumber;
        state.fileId = payload.fileId;
        state.docFile = null;
        state.hasAlreadyFetchedDocFile = false;
    },
    setAccountingCodes: function (state, accountingCodes) {
        if (!Array.isArray(accountingCodes)) {
            throw new Error('Accounting codes must be an array');
        }
        state.accountingCodes = accountingCodes;
    },
    addAccountingCodes: function (state, accountingCodes) {
        const toAdd = accountingCodes.filter((code) => {
            return !state.accountingCodes.find((c) => code.id === c.id);
        });
        state.accountingCodes = state.accountingCodes.concat(toAdd);
    },
    addRow: function (state, row) {
        state.rows.push(row);
    },
    updateRow: function (state, rowToUpdate) {
        // Find actual row
        const row = state.rows.find((row) => (row.id = rowToUpdate.id));

        /**
         * @todo : remove this condition when row will init
         */
        if (typeof row === 'undefined') {
            state.rows.push(rowToUpdate);
            return;
        }

        // Update it
        Object.assign(row, rowToUpdate);

        // To update rows, need to find its place in list
        const pos = state.rows.map((row) => row.id).indexOf(rowToUpdate.id);
        // remove it and place the updated row
        state.rows.splice(pos, 1, row);
    },
    selectRow: function name(state, rowid) {
        state.seletedRow = rowid;
    },
    toggleDunning: function (state) {
        if (state.dunningState != 'enabled' && state.dunningState != 'disabled') {
            throw new Error('Dunning cannot be toggled');
        }
        state.dunningState = state.dunningState == 'enabled' ? 'disabled' : 'enabled';
    },
    setSentDunnings: function (state, dunnings) {
        if (!Array.isArray(dunnings.data)) {
            throw new Error('Sent dunnings must be an array');
        }
        state.sentDunnings = dunnings.data;
        state.sentDunningsNumber = dunnings.total;
    },
    setPlannedDunnings: function (state, dunnings) {
        if (!Array.isArray(dunnings.data)) {
            throw new Error('Planned dunnings must be an array');
        }
        state.plannedDunnings = dunnings.data;
        state.plannedDunningsNumber = dunnings.total;
        state.plannedErrors = dunnings.errors;
    },
    setLinkedCreditNotes: function (state, linked) {
        state.creditnotes = linked;
        state.creditnotesLoaded = true;
    },
    setLinkedPurchases: function (state, linked) {
        state.purchases = linked;
        state.purchasesLoaded = true;
    },
    setLinkedExpenses: function (state, linked) {
        state.expenses = linked;
        state.expensesLoaded = true;
    },
    setLinkedItems: function (state, linked) {
        state.rows = linked;
        state.rowsLoaded = true;
    },
    setLinkedCustoms: function (state, linked) {
        state.customs = linked;
        state.customsLoaded = true;
    },
    setLinkedTimetrackings: function (state, linked) {
        state.timetrackings = linked;
        state.timetrackingsLoaded = true;
    },
    deleteLinkedPurchase: function (state, id) {
        const pos = state.purchases.map((link) => link.id).indexOf(id);
        state.purchases.splice(pos, 1);
    },
    deteleLinkedExpense: function (state, id) {
        const pos = state.expenses.map((link) => link.id).indexOf(id);
        state.expenses.splice(pos, 1);
    },
    deleteLinkedCustom: function (state, id) {
        const pos = state.customs.map((link) => link.id).indexOf(id);
        state.customs.splice(pos, 1);
    },
    deleteLinkedTimetracking: function (state, id) {
        const pos = state.timetrackings.map((link) => link.id).indexOf(id);
        state.timetrackings.splice(pos, 1);
    },
    addLinkedCustom: function (state, custom) {
        state.customs.push(custom);
    },
    updateLinkedCustom: function (state, customUpdated) {
        const pos = state.customs.map((custom) => custom.id).indexOf(customUpdated.id);
        state.customs.splice(pos, 1, customUpdated);
    },
    setStatistics: function (state, statistics) {
        state.statistics = statistics;
    },
    setFileId: function (state, fileId) {
        state.fileId = fileId;
        state.hasAlreadyFetchedDocFile = false;
    },
};
